$(window).on("load", function () {

    function MatchHeight() {
          $(".hero__title").matchHeight();
          $(".hero__subheading").matchHeight();
          $(".hero__description").matchHeight();
          $(".column__heading").matchHeight();
          $(".article__title").matchHeight();
          $(".column__icon h2.column__heading").matchHeight();
      
          $(".product-item .product-item__title").matchHeight();
          $(".product-item__price__holder").matchHeight();
          $(" body#solution .column__content").matchHeight();
       $(".product-item  .sort_content").matchHeight();
       $(" .product-item .product-item__info").matchHeight();
      $(".product-item__info  .sort_content").matchHeight();
      $(".product-item .product-item__info .sort_content").matchHeight();
    }

    MatchHeight();

  $("#ContactForm-business").keypress(function (e) {      
    var charCode = (e.which) ? e.which : event.keyCode    
    if (String.fromCharCode(charCode).match(/[^0-9]/g))    
        return false;                        
  });

  jQuery(document).on("click",  ' .related__wrapper ul.tabs > li,  .sidebar__item,   .active__filters__clear,  .active__filters__remove  ,    .collection__sidebar__close ,  .sidebar__item label, .sidebar__item  input , .collection__sidebar__buttons .btn ,  .popout--sort .popout-list__item ', function(event) { 
      console.log('filter1');
      setTimeout(function() {
     MatchHeight();
      }, 1500);        
  });

  $("#SearchInput--desktop").keypress(function (e) {
    setTimeout(function() {
      console.log('filter2');
      MatchHeight();
      }, 2000);  
  });

  $(".header__desktop__button").click(function (e) {
    setTimeout(function() {
      console.log('filter2');
      MatchHeight();
      }, 100);  
  });

});

